export const TypeOfService = new Map([
    ['BASIC', 'BASIC'],
    ['STANDARD', 'STANDARD'],
    ['PREMIUM', 'PREMIUM']
]);